import React, { Component, ReactElement } from 'react';

import UserProfile from '../UserProfile';

interface GridUserInformationProps {
  data: any;
  field?: string;
}

class GridUserInformation extends Component<GridUserInformationProps> {
  selectUser = (data: any, field = 'assignedUser'): any => (field !== 'assignedUser' || data.assignee ? data[field] : null);

  render(): ReactElement {
    const { data, field } = this.props;

    return (
      <span>
        <UserProfile tableMode showDetails user={this.selectUser(data, field)} />
      </span>
    );
  }
}

export default GridUserInformation;
